export default __webpack_public_path__ + "static/SmartViewPrint2-31145b920626c14669d91a9e26a2f4f6.webp";